(function() {
    window.addEventListener('DOMContentLoaded', function() {
        function hideElement(node) {
            if (!node) {
                return;
            }
            node.setAttribute('hidden', true);
        }
        const urlParams = new URLSearchParams(window.location.search);
        const isLimitedUI = urlParams.get('limitedUI');
        if (isLimitedUI) {
            const bannerNode = document.querySelector('.tbanner');
            if (bannerNode) {
                document.body.classList.remove('tbanner-body');
                bannerNode.remove();
            }
            for (const elem of document.querySelectorAll('.limited-ui-elem')) {
                hideElement(elem);
            }
        }
    });
    
    if (window.location.hostname == 'join.com') {
        (function() {
            var mmapiws = window.__mmapiws = window.__mmapiws || {};
            mmapiws.accountId = 988400;
            var loadDeviceJs = function() {
                var element = document.createElement('script');
                element.async = true;
                element.src = 'https://device.maxmind.com/js/device.js';
                document.body.appendChild(element);
            };
            if (window.addEventListener) {
                window.addEventListener('load', loadDeviceJs, false);
            } else if (window.attachEvent) {
                window.attachEvent('onload', loadDeviceJs);
            }
        })();
    }
})();

